<template lang="html">
  <main id="app-wrap" aria-core="Core Program">
    <div class="tap-inner">

      <div class="tap-key txt-c">
        <h1 class="txt-up">
          <strong>spa management system</strong>
          <p class="mg-t20">
            Spa Manager is a fully integrated software management system designed to meet the operating needs of almost any spa in the wellness industry.
            This system is so simple to understand and use receptionists require only minutes of training, and you will soon discover that managing your business has become easier and more effortless you ever thought possible.
          </p>
        </h1>
      </div>

      <ul class="tap-temp size-12">
        <li class>
          <div class="tap-logo">
            <img :src="require('~/assets/img/tap.png')"/>
          </div>
        </li>

        <li class>
          <p>TAP Technology Company Limited.</p>
          <p>131/44, Chang Puak, Muang Chiang Mai,</p>
          <p>Chiang Mai 50300</p>
          <p>Direction:
            <a href="//goo.gl/maps/yZkRovmdS6C2" target="_parent">Google Map,</a>
            <a @click="prop = true">Graphic Map</a>
          </p>
        </li>

        <li class>
          <p>09:00 AM - 17:00 PM (Monday - Friday)</p>
          <p>Tel: <a href="tel:+6653920144">053-920-144</a></p>
          <p>Fax: <a href="tel:+6653920145">053-920-145</a></p>
          <p class="tap-cs">
            <span>
              Customer Service: <a href="tel:+6653920127">053-920-127</a>
            </span>
            <span>
              <span>
                &nbsp;|&nbsp;
              </span>
              Email: <a href="mailto:cs@tap10.com">cs@tap10.com</a>
            </span>
          </p>
        </li>
      </ul>

    </div>

    <div :class="{'tap-pop': true, 'tap-on': prop}">
      <i class="tap-mask" @click="prop = false"/>
      <img :src="require('~/assets/img/map.png')"/>
    </div>
  </main>
</template>

<script>
export default {
  data () {
    return {
      prop: false
    }
  },

  created () {
    window.addEventListener('keyup', event => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.prop = false
      }
    })
  }
}
</script>

<style lang="less" scoped>
.tap-inner {
  position: relative;
  height: 100%;

  .tap-key {
    position: relative;
    max-width: 840px;
    margin: 0 auto;
    top: 40%;
    transform: translateY(-50%);

    strong {
      display: block;
      font-size: 58px;
      font-weight: 900;
      text-shadow: 0 5px 10px hsla(0, 0%, 0%, .09);
    }

    p {
      line-height: 1.88rem;
      opacity: .94;
      font-size: 1rem;
      font-weight: lighter;
      text-transform: capitalize;
    }
  }

  .tap-temp {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 5vh;
    margin: 0 auto;
    padding: 20px 0;
    line-height: 18px;

    display: flex;
    justify-content: center;
    background-color: hsla(0, 0%, 100%, .091);

    li {
      padding: 5px 40px;

      &:not(:first-child) {
        border-left: solid 1px hsla(0, 0%, 100%, .8);
      }
    }

    .tap-logo img {
      display: block;
      height: 72px;
      pointer-events: none;
    }
  }
}

@media screen and (max-width: 840px) {
  .tap-inner {
    .tap-key {
      padding: 0 15px;

      strong {
        font-size: 45px;
      }
    }
  }
}
@media screen and (max-width: 425px) {
  .tap-inner {
    .tap-key {
      top: 0;
      padding-top: 20px;
      transform: translateY(0);

      strong {
        font-size: 30px;
      }

      p {
        font-size: 14px;
        line-height: 21px;
      }
    }

    .tap-temp {
      position: relative;
      bottom: auto;
      display: block;
      padding: 20px 40px;
      margin-top: 40px;

      li {
        padding: 20px;

        .tap-logo img {
          margin: auto;
        }

        &:not(:first-child) {
          border-left: none;
          border-top: solid 1px hsla(0, 0%, 100%, .8);
        }

        .tap-cs {
          span + span {
            display: block;
            span { display: none }
          }
        }
      }
    }
  }
}

.tap-pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999;
  align-items: center;
  display: flex;

  .tap-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: hsla(220, 10%, 5%, .44);
    box-shadow: inset 0 0 99rem hsla(220, 10%, 5%, .44);
  }

  img {
    position: relative;
    display: block;
    width: 100%;
    margin: 0 auto;
    max-width: 840px;
    transition: transform 320ms;
  }

  transition: opacity 480ms;
  &:not(.tap-on) {
    opacity: 0;
    pointer-events: none;

    img {
      transform: scale(.91);
    }
  }
  &.tap-on {
    opacity: 1;
    pointer-events: auto;

    img {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue